export default __webpack_public_path__ + "static/media/excelIcon.198baff4.svg";